import React from 'react';
import PropTypes from 'prop-types';
import Popover, { ArrowContainer } from 'react-tiny-popover';

import warningIcon from '../../images/warning.svg';

const HoverComponent = React.forwardRef((props, ref) => {
  let { isPopoverOpen, Element, text, textEditingElement } = props;
  return (
    <Popover
      isOpen={isPopoverOpen}
      position={['bottom', 'left']}
      onClickOutside={() => { isPopoverOpen = false; }}
      containerStyle={{ opacity: 1, padding: 0 }}
      containerClassName="popover-hover"
      content={({ position, targetRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          targetRect={targetRect}
          popoverRect={popoverRect}
          arrowColor={'rgb(245, 245, 245)'}
          arrowSize={10}
          arrowStyle={{ opacity: 1, left: '25px' }}
        >
        <div className="popover-comp">
          <div
            className='hover-comp'
            onClick={() => {
              isPopoverOpen = !isPopoverOpen;
            }}
          >
            <img src={warningIcon} alt={'Warning'} />
            <span style={{ marginLeft: '10px' }}>Open</span>
            <span className="braces-text">{`(, {`}</span>
            <span>and</span>
            <span className="braces-text">{`[`}</span>
            <span>are not allowed in the edited label</span>
          </div>
        </div>
        </ArrowContainer>
      )}
    >
      <div><Element ref={ref} {...textEditingElement}>{text}</Element></div>
    </Popover>
  );
});

HoverComponent.propTypes = {
  isPopoverOpen: PropTypes.bool,
  textEditingElement: PropTypes.shape({}),

};
export default HoverComponent;
